import axios from "axios"
import qs from "qs"
const ajax = axios.create({
    baseURL: 'https://crawlerdata.acemap.cn/',
    headers: {
        Accept: "*/*",
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    timeout: 500000,
    transformRequest: [
        function(data, headers) {
            // 对 data 进行任意转换处理
            if (headers['Content-Type'] === "application/x-www-form-urlencoded;charset=utf-8")
                return qs.stringify(data);
            else
                return data;
        }
    ]
})

// 拦截请求
ajax.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 拦截响应
ajax.interceptors.response.use(
    response => {
        // if (process.server && !response.data.success) {
        //     console.log("报错API:" + response.config.url)
        //     console.log("报错id:" + response.config.data)
        // }
        return response
    },
    error => {
        // if (process.server)
        //     console.log(['Server-side API Error', error.config, error.response]);
        // let message = '';
        // if (error.response.status === 403)
        //     message = error.response.data.detail;
        // else if (error.response.status === 404)
        //     message = 'Some APIs not found <br> We will fix them as soon as possible';
        // else
        //     message = 'Some unknown errors occurs <br> We will fix them as soon as possible';

        console.log(message)
            // Swal.fire({
            //   title: 'Sorry!',
            //   html: message,
            //   icon: 'error',
            //   confirmButtonText: 'OK'
            // }).then(() => {
            //   if (error.config.reloadOnError)
            //     window.location.reload();
            //   else if (error.config.closeOnError)
            //     window.close();
            // });
            // let loadingInstance = Loading.service({})
            // Loading.service({}).close();
        return Promise.reject(error);
    }
)
export default ajax